<template>
  <div>
    <view-table
        ref="viewTable"
        :filter="filter"
        :limits="limits"
        :columns-property="columnsProperty"
        module="basic"
        url="inspectionReports/po"
        @select="selectHandle"
        @delete="deleteHandle"
        @reset="resetHandle"
        @addOrEdit="addEditHandle">
      <template slot="otherBtn">
        <!--            <el-button v-if="limits.editAuth" type="primary" :disabled="!selection.length" @click="submit"> 提交</el-button>-->
        <!--            <el-button v-if="cancelAuth" type="primary" :disabled="!selection.length" @click="repeal"> 撤销</el-button>-->
        <el-button
            type="primary"
            :loading="exportLoading"
            @click="exportExcel()">
          导出
        </el-button>
      </template>
      <template slot="adSearch">
        <el-form :inline="true" :model="filter" @submit.native.prevent @keyup.enter.native="loadData(1)">
          <el-form-item label="编号">
            <el-input v-model.trim="filter.no" placeholder="请输入" clearable/>
          </el-form-item>
          <el-form-item label="关联单据">
            <el-input v-model.trim="filter.refBillNo" placeholder="请输入" clearable/>
          </el-form-item>
          <el-form-item label="状态">
            <el-select v-model="filter.status" clearable>
              <el-option label="草稿" :value="0"/>
              <el-option label="复检" :value="10"/>
              <el-option label="审核" :value="11"/>
              <el-option label="通过" :value="20"/>
            </el-select>
          </el-form-item>
          <el-form-item label="物料编号">
            <el-input v-model.trim="filter.materialNo" placeholder="请输入" clearable/>
          </el-form-item>
          <el-form-item label="物料名称">
            <el-input v-model.trim="filter.materialName" placeholder="请输入" clearable/>
          </el-form-item>
          <el-form-item label="规格型号">
            <el-input v-model.trim="filter.specification" placeholder="请输入" clearable/>
          </el-form-item>
          <el-form-item label="制单人">
            <el-input v-model.trim="filter.creatorName" placeholder="请输入" clearable/>
          </el-form-item>
          <el-form-item label="供应商">
            <el-input v-model.trim="filter.supplierName" placeholder="请输入" clearable/>
          </el-form-item>
          <el-form-item label="创建日期">
            <el-date-picker
                v-model="createDateRange"
                type="daterange"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                value-format="yyyy-MM-dd"
                @change="dateRangeChange('createDateRange', 'startCreateDate', 'endCreateDate')"/>
          </el-form-item>
        </el-form>
      </template>
      <template slot="actionBtn" slot-scope="scope">
        <el-button
            v-if="addAuth"
            type="primary"
            :disabled="scope.row.status !== 0"
            @click="submitHandle(scope.row)">
          提交
        </el-button>
      </template>
    </view-table>
    <!-- 编辑 -->
    <purchase-report-edit ref="purchaseReportEdit" @save-success="loadData"/>
  </div>
</template>

<script>
import ViewTable from "@/components/ViewTable.vue";
import PurchaseReportEdit from "./PurchaseReportEdit";

export default {
  name: "PurchaseReportList",
  components: {
    ViewTable,
    PurchaseReportEdit,
  },
  data() {
    return {
      limits: {
        detailAuth: this.$auth(446),
        // addAuth: this.$auth(447),
        editAuth: this.$auth(448),
        delAuth: this.$auth(449),
      },
      addAuth: this.$auth(447),
      importLoading: false,
      exportLoading: false,
      mainBoxHeight: 0,
      data: [],
      createDateRange: [],
      filterText: "",
      filter: {
        no: "",
        refBillNo: "",
        billType: -1,
        materialNo: "",
        materialName: "",
        specification: "",
        creatorName: "",
        supplierName: "",
        status: "",
        startCreateDate: "",
        endCreateDate: "",
      },
      columnsProperty: [
        {
          key: "no",
          align: "center",
          render: (h, params) => {
            return h(
                "span",
                {
                  style: {
                    color: "#2d8cf0",
                    cursor: "pointer",
                  },
                  on: {
                    click: () => {
                      this.$refs.purchaseReportEdit.open(params.row, true, true);
                    },
                  },
                },
                params.row.no,
            );
          },
        },
        {
          key: "action",
          align: "center",
          width: 200,
          slot: "action",
          fixed: "right",
        },
      ],
      selection: [],
    };
  },
  watch: {
    "filter.startCreateDate": {
      handler(newVal) {
        if (newVal) {
          this.createDateRange = [];
          this.createDateRange.push(this.filter.startCreateDate);
          this.createDateRange.push(this.filter.endCreateDate);
        }
      },
    },
  },

  methods: {
    dateRangeChange(timeRange, timeStart, timeEnd) {
      if (this[timeRange]) {
        this.filter[timeStart] = this[timeRange][0];
        this.filter[timeEnd] = this[timeRange][1];
      } else {
        this.filter[timeStart] = "";
        this.filter[timeEnd] = "";
      }
    },
    addEditHandle(row) {
      this.$refs.purchaseReportEdit.open(row, true, false);
    },

    exportExcel() {
      this.exportLoading = true;
      this.$http
          .exportFile("basic","inspectionReports/export", this.filter)
          .then(res => {
            console.log(res);
            let blob = new Blob([res.data]);
            let fileName = decodeURI(res.headers.filename);
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              navigator.msSaveBlob(blob, fileName);
            } else {
              let a = document.createElement("a");
              a.href = URL.createObjectURL(blob);
              a.download = fileName;
              a.style.display = "none";
              document.body.appendChild(a);
              a.click();
              URL.revokeObjectURL(a.href);
              document.body.removeChild(a);
            }
            this.exportLoading = false;
          })
          .catch(() => {
            this.exportLoading = false;
          });
    },

    loadData(pageNum) {
      this.$refs.viewTable.loadData(pageNum);
    },

    // 删除(单删、多删)
    deleteHandle(row) {
      // this.$confirm("确定删除吗?", "提示", {type: "warning"})
      //     .then(() => {
      this.$http.delete("basic", "inspectionReports", row.pkId).then((res) => {
        if (res.success) {
          this.loadData();
          this.$message.success("删除成功");
        }
      });
      // })
      // .catch(() => {
      // });
    },
    submitHandle(row) {
      this.$confirm("确定提交吗?", "提示", {type: "warning"}).then(() => {
        this.$http.post("basic", "inspectionReports/submit/" + row.pkId).then(() => {
          this.loadData(1);
          this.$message.success("提交成功");
          this.selection = [];
        });
      });
    },
    // checkBox
    selectHandle(selection) {
      this.selection = selection;
    },
    // 重置
    resetHandle(filter) {
      this.filter = Object.assign(this.filter, filter);
    },
    // 未提交、退单可以编辑删除
    otherAuth(row) {
      if (row.status === 0) {
        return {
          editAuth: false,
          delAuth: false,
        };
      } else {
        return {
          editAuth: true,
          delAuth: true,
        };
      }
    },
  },
};
</script>
<style scoped>
</style>

<style>
</style>
